import React from "react";

export default function StepOneMeals({ data, setData, onNext }) {
  const handleGuestToggle = (mealIndex, guestName) => {
    const updatedMeals = [...data.meals];
    const meal = updatedMeals[mealIndex];
    if (!meal.assigned) meal.assigned = [];

    const index = meal.assigned.findIndex((a) => a.guest === guestName);
    if (index > -1) {
      meal.assigned.splice(index, 1);
    } else {
      meal.assigned.push({ guest: guestName });
    }

    setData({ ...data, meals: updatedMeals });
  };

  return (
    <div>
      <h2 style={{ fontSize: "20px", marginBottom: "1rem" }}>
        Assign Meals to Guests
      </h2>
      {data.meals?.length ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {data.meals.map((meal, i) => (
            <div
              key={i}
              style={{
                background: "#E6E6FA",
                borderRadius: "12px",
                padding: "1rem",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "4px",
                }}
              >
                {meal.name}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#333",
                  marginBottom: "0.5rem",
                }}
              >
                RM {meal.price.toFixed(2)}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                {data.guests.map((guest, gIndex) => (
                  <label
                    key={gIndex}
                    style={{
                      fontSize: "12px",
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "0.3rem 0.6rem",
                      border: "1px solid #ccc",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.3rem",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={meal.assigned?.some((a) => a.guest === guest)}
                      onChange={() => handleGuestToggle(i, guest)}
                      style={{ transform: "scale(0.9)" }}
                    />
                    {guest}
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No meals detected. Please scan receipt first.</p>
      )}
    </div>
  );
}
